import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthService } from "@assoanalytics/app/core/services/auth.service";
import { NavService } from "../services/nav.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private navService: NavService,
  ) {}

  canActivate(): boolean {
    // L'utente è autenticato, permetti l'accesso alla route
    if (this.authService.getCurrentUser()) {
      return true;
    }

    // Estrai dinamicamente tutti i parametri della querystring
    const searchParams = new URLSearchParams(window.location.search);
    const params: { [key: string]: string } = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });

    this.navService.redirectUrl.next({
      url: window.location.pathname,
      params: params,
    });

    // L'utente non è autenticato, reindirizza alla pagina di loading
    this.router.navigate(["/loading"]);
    return false;
  }
}
